module.exports = __webpack_public_path__ + "mygolf2uLogo.269b82a1db2d6af78870.png";


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/assets/images/mygolf2uLogo.png
// module id = ../../../../../src/assets/images/mygolf2uLogo.png
// module chunks = styles